"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function npxs(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.9929 3.01721C7.04289 3.01721 3.01389 7.04621 3.01389 11.9962C3.01389 16.9462 7.04289 20.9827 12.0004 20.9827C16.9571 20.9827 20.9861 16.9537 20.9861 11.9962C20.9861 7.03946 16.9504 3.01721 11.9936 3.01721H11.9929ZM11.9929 20.2897C7.42389 20.2897 3.69939 16.5727 3.69939 11.9962C3.70689 7.42721 7.42389 3.70946 11.9929 3.70946C16.5626 3.70946 20.2871 7.42721 20.2871 12.0037C20.2871 16.5727 16.5694 20.2905 11.9929 20.2905V20.2897Z", fill: color }),
        React.createElement("path", { d: "M7.34442 8.00926L8.00442 7.34851L11.5204 10.8638L10.8597 11.5238L7.34442 8.00926ZM12.4579 13.125L13.1187 12.4643L16.6339 15.9795L15.9732 16.6395L12.4579 13.125ZM11.3367 11.9985L11.9967 11.3385L12.6627 12.003L12.0027 12.6645L11.3367 11.9985ZM12.4677 10.8923L15.9829 7.37776L16.6429 8.03851L13.1284 11.5538L12.4677 10.8923ZM7.36992 15.9833L10.8844 12.4688L11.5452 13.1288L8.03067 16.644L7.36992 15.9833Z", fill: color }));
}
exports["default"] = npxs;
//# sourceMappingURL=npxs.js.map